var map = {
	"./wenjian-doc.png": "./src/assets/images/wenjian-doc.png",
	"./wenjian-img.png": "./src/assets/images/wenjian-img.png",
	"./wenjian-pdf.png": "./src/assets/images/wenjian-pdf.png",
	"./wenjian-ppt.png": "./src/assets/images/wenjian-ppt.png",
	"./wenjian-video.png": "./src/assets/images/wenjian-video.png",
	"./wenjian-wenjian.png": "./src/assets/images/wenjian-wenjian.png",
	"./wenjian-xls.png": "./src/assets/images/wenjian-xls.png",
	"./wenjian-zip.png": "./src/assets/images/wenjian-zip.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/wenjian\\-.*\\.png$";